import { useTranslations } from 'hooks/useTranslations';
import { ChipItem } from './ChipItem';

export const InsuranceParticipantChip = () => {
  const translations = useTranslations();
  const strings = translations.policy.travelCancellation;

  return <ChipItem title={strings.policyParticipant()} color="primary" />;
};
